<template>
    <div
        class="kgr-inputGroup"
        :class="{ 'with-errors': error.forField('file') }"
    >
        <div class="kgr-inputGroup__label ui-droppable">
            {{ $t('Bild') }}
        </div>

        <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--top kgr-row kgr-row--smallMargin">
            <div
                v-if="!loading"
                class="kgr-postfix__fixed"
            >
                <img
                    :src="imageUrl"
                    :alt="location.name"
                />
            </div>
            <div class="kgr-postfix__fluid">
                <template v-if="imageFile">
                    <kgr-button
                        :value="$t('Bild hochladen')"
                        :pending="pendingUpload"
                        type="blue"
                        @click="uploadImage"
                    />
                </template>
                <template v-if="!loading && location.hasImage && !imageFile">
                    <a
                        class="kgr-button kgr-button--small kgr-button--danger"
                        href="javascript:void(0);"
                        @click="deleteImage()"
                    >{{ $t('Bild löschen?') }}</a>
                    <input
                        id="check_remove_image"
                        type="hidden"
                        value="0"
                        name="check_remove_image"
                    />
                </template>
            </div>
        </div>
        <kgr-drop-file
            ref="dropFile"
            show-size
            jpg-png-gif-only
            @change="onImageChange"
        />

        <div
            v-if="error.forField('file')"
            class="kgr-inputGroup__text kgr-inputGroup__text--error"
        >
            {{ error.messageForField('file') }}
        </div>
        <div class="kgr-inputGroup__text">
            {{ $t('Hier kannst du ein Bild einfügen. Die Datei (z.B. JPG, PNG oder GIF) sollte eine Mindestbreite von 300 Pixel haben und darf eine Dateigröße von 2 MB nicht überschreiten.') }}
        </div>
    </div>
</template>

<script>
import DropFile from '../../components/common/form/input/DropFile.vue';
import Error from '../../js/model/Error.js';
import KgrButton from '../../components/common/form/button/KgrButton.vue';
import LocationRepository from '../../js/repository/LocationRepository.js';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-drop-file': DropFile,
    },
    props: {
        locationId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            imageFile: null,
            error: new Error(),
            pendingUpload: false,
            loading: true,
            cacheBreaker: Date.now(),
            location: null,
        }
    },
    computed: {
        imageUrl() {
            return this.location.imageUrl + '?v=' + this.cacheBreaker;
        },
    },
    created() {
        LocationRepository.find(this.locationId)
            .then(location => {
                this.error = new Error();
                this.location = location;
            })
            .catch(error => this.handleError(error))
            .finally(() => this.loading = false)
    },
    methods: {
        deleteImage() {
            showConfirm(this.$t('confirm'), this.$t('Soll das Bild wirklich gelöscht werden?'), () => {
                LocationRepository.removeImage(this.location)
                    .then(() => {
                        this.error = new Error();
                        this.cacheBreaker = Date.now();
                        this.location.hasImage = false;
                        this.$forceUpdate();
                        this.$notify.success('Bild erfolgreich gelöscht');
                    })
                    .catch(error => this.handleError(error));
                this.imageFile = null;
            }, 'Ok');
        },
        onImageChange(imageFile) {
            this.imageFile = imageFile;
        },
        uploadImage() {
            if (this.imageFile) {
                this.pendingUpload = true;
                LocationRepository.uploadImage(this.location, this.imageFile)
                    .then(() => {
                        this.error = new Error();
                        this.cacheBreaker = Date.now();
                        this.location.hasImage = true;
                        this.imageFile = null;
                        this.$refs.dropFile.resetFiles();
                        this.$forceUpdate();
                        this.$notify.success('Bild erfolgreich hochgeladen');
                    })
                    .catch(error => this.handleError(error))
                    .finally(() => this.pendingUpload = false)
            }
        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
